import { usePageDrawer } from './PageDrawerContext';

interface PageDrawerProps {
  /** Drawer content (e.g. StreamDrawerContent). When not provided, renders nothing. */
  readonly content?: React.ReactNode;
}

/**
 * Renders the drawer panel content. Used as the child of the resizable drawer Panel.
 * Content is passed from the layout (e.g. stream page passes StreamDrawerContent).
 */
export function PageDrawerContent({ content }: PageDrawerProps) {
  const { open } = usePageDrawer();

  if (!open || !content) {
    return null;
  }

  return <>{content}</>;
}
